module.exports = {
	"particles": {
		"number": {
			"value": 10,
			"density": {
				"enable": true,
				"value_area": 400
			}
		},
		"color": {
			"value": "#757575"
		},
		"shape": {
			"type": "polygon",
			"stroke": {
				"width": 0,
				"color": "#757575"
			},
			"polygon": {
				"nb_sides": 6
			}
		},
		"opacity": {
			"value": 0.25,
			"random": true,
			"anim": {
				"enable": true,
				"speed": 1,
				"opacity_min": 0.25,
				"sync": false
			}
		},
		"size": {
			"value": 10,
			"random": true,
			"anim": {
				"enable": true,
				"speed": 5,
				"size_min": 0.25,
				"sync": false
			}
		},
		"line_linked": {
			"enable": true,
			"distance": 150,
			"color": "#757575",
			"opacity": 0.7,
			"width": 1
		},
		"move": {
			"enable": true,
			"speed": 0.3,
			"direction": "top",
			"random": false,
			"straight": false,
			"out_mode": "out",
			"bounce": false,
			"attract": {
				"enable": false,
				"rotateX": 100,
				"rotateY": 100
			}
		}
	},
	"interactivity": {
		"detect_on": "window",
		"events": {
			"onhover": {
				"enable": true,
				"mode": "grab"
			},
			"onclick": {
				"enable": true,
				"mode": "repulse"
			},
			"resize": true
		},
		"modes": {
			"grab": {
				"distance": 200,
				"line_linked": {
					"opacity": 0.9
				}
			},
			"bubble": {
				"distance": 120,
				"size": 16,
				"duration": 2,
				"opacity": 0.25,
				"speed": 0.1
			},
			"repulse": {
				"distance": 200,
				"duration": 10
			},
			"push": {
				"particles_nb": 10
			},
			"remove": {
				"particles_nb": 10
			}
		}
	},
	"retina_detect": true
};


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Particle/particles.json
// module id = 808
// module chunks = 0